export const BREAK_POINTS = {
  mobile: 585,
  tablet: 768,
  pc: 921,
};
